import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Briefcase, ArrowRight, GraduationCap } from 'lucide-react';
const TRACKS = [{
  icon: Wrench,
  eyebrow: 'Diplomado 01',
  title: 'Capacidades técnicas',
  description: 'Orientado al fortalecimiento de capacidades técnicas para la gestión de la información ambiental y territorial.',
  href: 'https://programatefos.com/diplomado-en-capacidades-tecnicas/',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80'
}, {
  icon: Briefcase,
  eyebrow: 'Diplomado 02',
  title: 'Capacidades gerenciales',
  description: 'Orientado al fortalecimiento de capacidades gerenciales para la toma de decisiones en el sector ambiental.',
  href: 'https://programatefos.com/diplomado-en-capacidades-gerenciales/',
  image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&q=80'
}];
export function DiplomadosVirtuales() {
  return <section id="diplomados" className="py-24 md:py-32 px-4 md:px-8 scroll-mt-24" data-id="element-152" data-mp="3rye9hecczn34">
      <div className="max-w-[1400px] mx-auto" data-id="element-153" data-mp="3g3tq2vto2lja">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-154" data-mp="3b6k4xsdb8w19">
          <div className="lg:col-span-5" data-id="element-155" data-mp="3b8ede77eavog">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-156" data-mp="3p6l2axud9lbz">
              Formación complementaria
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-forest leading-[1.05]" data-id="element-157" data-mp="3l2dh3an4anii">
              Diplomados virtuales para la gobernanza territorial y ambiental
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-158" data-mp="2sdppyyfot3x1">
            <p className="text-lg md:text-xl text-charcoal/85" data-id="element-159" data-mp="3691ufxjna8r5">
              Entre noviembre de 2024 y marzo de 2025, con el apoyo del
              Ministerio de Ambiente y Desarrollo Sostenible y en alianza con la
              Universidad de Medellín, se diseñaron dos diplomados virtuales:{' '}
              <em className="not-italic font-medium text-charcoal" data-id="element-160" data-mp="29nhzbft6c5xq">
                "El ordenamiento territorial y ambiental como aporte a la
                gobernanza de los territorios"
              </em>
              .
            </p>
            <p data-id="element-161" data-mp="me860o8rqftu">
              Estos programas buscan fortalecer la gobernanza y la gestión de la
              información ambiental y territorial para la toma de decisiones.
              Ambos están dirigidos a funcionarios de entidades gubernamentales
              vinculadas al sector ambiental.
            </p>
          </div>
        </div>

        {/* Two tracks */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-162" data-mp="3o09wq3hkpn5">
          {TRACKS.map((track, i) => {
          const Icon = track.icon;
          return <motion.a key={track.title} href={track.href} target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="group relative block h-[360px] md:h-[420px] overflow-hidden bg-forest focus:outline-none focus-visible:ring-2 focus-visible:ring-clay-light" data-id="element-163" data-mp="8oo7jum804qc" data-mpi={i}>
                <img src={track.image} alt={track.title} className="absolute inset-0 w-full h-full object-cover opacity-50 transition-transform duration-700 group-hover:scale-105" data-id="element-164" data-mp="2pvo7tbbiqjcy" />
                <div className="absolute inset-0 bg-forest/50" data-id="element-165" data-mp="2ktywdukdw3oc" />
                <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-between" data-id="element-166" data-mp="2gt56wwramgtc">
                  <div className="w-14 h-14 border-2 border-bone/40 flex items-center justify-center" data-id="element-167" data-mp="2bwetyiasc1c5">
                    <Icon className="text-bone" size={26} strokeWidth={1.5} data-id="element-168" data-mp="26y3i620xjgra" />
                  </div>
                  <div data-id="element-169" data-mp="a3qm1vn74pq1">
                    <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold mb-3 block" data-id="element-170" data-mp="a25zotb1cd39">
                      {track.eyebrow}
                    </span>
                    <h3 className="font-serif text-bone text-3xl mb-3 leading-tight" data-id="element-171" data-mp="2yxnh01qf0d3r">
                      {track.title}
                    </h3>
                    <p className="text-bone/80 text-sm font-light leading-relaxed mb-4" data-id="element-172" data-mp="2oz7uyd68vu14">
                      {track.description}
                    </p>
                    <span className="inline-flex items-center gap-2 text-clay-light text-sm font-medium" data-id="element-173" data-mp="2tw7su0sxxqh5">
                      Ver diplomado
                      <ArrowRight size={16} className="transform group-hover:translate-x-1 transition-transform" data-id="element-174" data-mp="2jzmolhoqwjed" />
                    </span>
                  </div>
                </div>
              </motion.a>;
        })}
        </div>

        {/* CTA */}
        <motion.a href="#" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="group flex flex-col sm:flex-row sm:items-center justify-between gap-6 bg-bone-dark p-8 md:p-10" data-id="element-175" data-mp="2b7t1tdimicgc">
          <div className="flex items-center gap-5" data-id="element-176" data-mp="1hod599266zni">
            <GraduationCap className="text-clay flex-none" size={36} strokeWidth={1.5} data-id="element-177" data-mp="1dm9ny3stl0ub" />
            <p className="font-serif text-forest text-xl md:text-2xl leading-snug" data-id="element-178" data-mp="1rlrhsxkz34aj">
              Conoce los contenidos, materiales y resultados de estos procesos
              de formación.
            </p>
          </div>
          <span className="inline-flex items-center gap-2 text-clay font-medium flex-none" data-id="element-179" data-mp="20lxq851tde2u">
            Explorar diplomados
            <ArrowRight size={18} className="transform group-hover:translate-x-1 transition-transform" data-id="element-180" data-mp="1wk2s19f6jgta" />
          </span>
        </motion.a>
      </div>
    </section>;
}